import { render, staticRenderFns } from "./radiologue-card.vue?vue&type=template&id=37cac544&scoped=true"
import script from "./radiologue-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./radiologue-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./radiologue-card.vue?vue&type=style&index=0&id=37cac544&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cac544",
  null
  
)

export default component.exports